import { cn, Typography } from '@kiiwi/ui';
import React, { PropsWithChildren } from 'react';

type ProCardDescriptionProps = {
  className?: string;
};

const ProCardDescription = ({
  className,
  children,
}: PropsWithChildren<ProCardDescriptionProps>) => {
  return (
    <div
      className={cn(
        'flex h-full items-center justify-center rounded-lg border border-neutral bg-surface-lighter px-4 py-3 text-center',
        className,
      )}
    >
      <Typography>{children}</Typography>
    </div>
  );
};

export default ProCardDescription;
